import { config } from "../config";

export const fetchChatGPTResponse = async (
  prompt: string,
  userInput: string
): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('prompt', prompt);
    formData.append('userInput', userInput);
    
    const response = await fetch(`${config.API_BASE_URL}?request=/chatGPT`, {
      method: 'POST',
      body: formData
    });
    
    const data = await response.json();
    
    if (data.status !== 200) {
      throw new Error(data.error || 'API request failed');
    }
    
    return data.result || 'Keine Antwort erhalten';
  } catch (error) {
    console.error('Error fetching ChatGPT response:', error);
    throw new Error('Failed to fetch response from ChatGPT');
  }
};